import PropTypes from 'prop-types';
import React from 'react';
import Card from 'components/Card';
import ChecklistYesNoQuestion from './checklistYesNoQuestion';
import ChecklistRescheduler from './checklistRescheduler';
import S from '../styles.scss';

const IfiHaltCard = ({
  powerAnswered,
  handleSpecificAnswered,
  haltMessage,
  newDate,
  newDateNote,
  newDateError,
  handleNewDate,
  handleNewDateNote,
  submitNewDate,
  errors,
}) => <Card>
  <div className={S.headerContainer}>
    <h4 className={S.title}>Potential Halt</h4>
  </div>
  <ChecklistYesNoQuestion
    phaseSpecific
    canShow
    text="Will the power be on and available for our installers to use during the installation?"
    yesDisabled={powerAnswered === 'yes'}
    noDisabled={powerAnswered === 'no'}
    handleAnswered={handleSpecificAnswered}
    answeredArgs={['powerAnswered', 'customer_has_power']}
  />
  <ChecklistRescheduler
    condition={powerAnswered === 'no'}
    text={haltMessage}
    newDate={newDate}
    handleNewDate={handleNewDate}
    errors={errors}
    newDateNote={newDateNote}
    handleNewDateNote={handleNewDateNote}
    submitNewDate={submitNewDate}
    newDateError={newDateError}
  />
</Card>;

IfiHaltCard.propTypes = {
  powerAnswered: PropTypes.string,
  handleSpecificAnswered: PropTypes.func,
  haltMessage: PropTypes.string,
  newDate: PropTypes.string,
  newDateNote: PropTypes.string,
  newDateError: PropTypes.string,
  handleNewDate: PropTypes.func,
  handleNewDateNote: PropTypes.func,
  submitNewDate: PropTypes.func,
  errors: PropTypes.object,
};

export default IfiHaltCard;



// WEBPACK FOOTER //
// ./client/app/screens/main/screens/phases/phaseShow/tabs/phaseSchedulingChecklist/components/ifiHaltCard.jsx